import React from 'react';

import s from './WrapperPage.module.css';

const WrapperPage = ({children, notion}) => (
    <div className={`${s.wrapper} ${notion ? s.notion : ''}`}>
        {children}
    </div>
);

export default WrapperPage;